import {
  HEADER_BLOCK_DATA,
  BLOGS_BLOCK_DATA,
  RELIVE_MEMORIES_BLOCK_DATA,
  READY_ORDER_BLOCK_DATA,
  WIZARD_STEPS_DIGITIZE_DATA,
  NEW_BANNER_WITH_IMAGE_BLOCK_DATA,
  TRUST_EXPERIENCE_TABS_DATA,
  TRUST_EXPERIENCE_TITLE_LIST_DATA,
} from '../../shared-blocks';
import BIG_IMAGE_WITH_TABS_BLOCK_DIGITIZE from '../digitize-blocks/big-image-tabs-block';

const DIGITIZE_PAGE_DATA = [
  {
    componentName: 'headerBlock',
    content: HEADER_BLOCK_DATA,
  },
  {
    componentName: 'bigImageWithTabsBlock',
    content: BIG_IMAGE_WITH_TABS_BLOCK_DIGITIZE,
  },
  {
    componentName: 'wizardSteps',
    content: WIZARD_STEPS_DIGITIZE_DATA,
  },
  {
    componentName: 'readyOrderBlock',
    content: READY_ORDER_BLOCK_DATA,
  },
  {
    componentName: 'newBannerWithImageBlock',
    content: {
      id: null,
      isEdit: false,
      index: 0,
      withGrayBackground: true,
      ...NEW_BANNER_WITH_IMAGE_BLOCK_DATA,
    },
  },
  {
    componentName: 'trustExperienceBlock',
    content: {
      tabs: TRUST_EXPERIENCE_TABS_DATA,
      titleList: TRUST_EXPERIENCE_TITLE_LIST_DATA,
    },
  },
  {
    componentName: 'reliveMemoriesBlock',
    content: RELIVE_MEMORIES_BLOCK_DATA,
  },
  {
    componentName: 'blogsBlock',
    content: BLOGS_BLOCK_DATA,
  },
];

export default DIGITIZE_PAGE_DATA;
